import React, { useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { reduxForm, Field } from "redux-form";

import { FormField } from "../../../../sharedComponents/formField";
import { getFoodGroupList, searchIngredients } from "../../../../store/actions";
import { objToQueryString } from "../../../../utils/common";
import { RecipeKeys } from "../../../../constants/recipeConstants";

const SearchIngredientsForm = ({
	handleSubmit,
	submitting,
	getFoodGroupList,
	searchIngredients,
	searchIngredientResults,
	onSearch
}) => {

	useEffect(() => {
		if(!searchIngredientResults) {
			searchIngredients(`limit=${RecipeKeys.SEARCH_INGREDIENT_RESULTS_LIMIT}`);
		}
	});

	const validateForm = (values) => {
		onSearch(true);
		searchIngredients(`${objToQueryString(values)}&limit=${RecipeKeys.SEARCH_INGREDIENT_RESULTS_LIMIT}`);
	};

	return (
		<React.Fragment>
			<h5 className="text-primary-dark mb-2">Find the ingredient you want to add</h5>
			<form className="row" onSubmit={handleSubmit(validateForm)}>
				<div className="col-9">
					<Field name="terms" label="Search terms" type="text" component={FormField} />
				</div>
				<div className="col-3">
					<button type="submit" className="w-100 btn btn-primary mt-4" disabled={submitting}>
						Search
					</button>
				</div>
			</form>
		</React.Fragment>
	);
};

const mapStateToProps = (state) => {
	return {
		searchIngredientResults: get(state, "AddRecipe.searchIngredientResults.results", null),
	};
};

const mapDispatchToProps = {
	getFoodGroupList,
	searchIngredients
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	reduxForm({
		form: "SearchIngredientsForm",
		enableReinitialize: true
	})(SearchIngredientsForm)
);
